import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { of, Subject } from 'rxjs';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@UntilDestroy()

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    debouncer = new Subject<any>();

    constructor(@Inject(PLATFORM_ID) private platformId: any,
        private http: HttpClient) {
        this.debouncer.pipe(
            untilDestroyed(this),
            map(e => ({ data: e, time: Date.now() })),
            distinctUntilChanged((a, b) => (a.data.name == b.data.name) && a.data.itemId == b.data.itemId && (a.time > b.time - 10000)), switchMap((e) => {
                return this.collectEvent(e.data);
            })
        ).subscribe();
    }


    collectEvent(params) {
        if (isPlatformBrowser(this.platformId)) {
            return this.http.post<any>(`${environment.apiUrl}/events`, params);

        } else
            return of(true);
    }

}


